import type { FaireProductEntity } from "../../entity_types/product";

export const p_2w45azs6ge: FaireProductEntity = {
  token: "p_2w45azs6ge",
  type: "product",
  name: "Cute Coffee-Themed Sticker Pack \u2013 Fun & Aesthetic Designs",
  brandName: "Magnifique Hearts",
  imageUrl:
    "https://cdn.faire.com/fastly/69b0d0d06c74f92521e20a399eae5c15de262a0c9e38ca4ee7086062197073c3.webp",
  priceDollars: 1.29,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/6551349fb371349f0dfd6d22c41f0c86d53dbde118ad3cd6761d5ba618c645ff.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
